export enum AnimatedButtonState {
    Default = 'DEFAULT',
    Submitting = 'SUBMITTING',
    Success = 'SUCCESS',
    Error = 'ERROR'
}
